import AppConfig from "util/AppConfig";
const useFooterCustomization = () => {
  var _a, _b, _c, _d;
  return {
    enabled: ((_d = (_c = (_b = (_a = AppConfig) == null ? void 0 : _a.branding) == null ? void 0 : _b.call(_a)) == null ? void 0 : _c.footer) == null ? void 0 : _d.enabled) !== false
  };
};
export default useFooterCustomization;
